import * as React from 'react';

const storeFinderContextDefaultValues = {
    config: {
        googleMapsId: '',
        hidePhone: false,
        hideEmail: false,
        withUrlParams: false,
        storeFilter: ()=>true
    },
    stores: [],
    hoveredStore: null,
    activeMapInfoWindow: null,
    setActiveMapInfoWindow: ()=>null
    ,
    isStoresLoading: false,
    isLocationSelected: false,
    searchQuery: '',
    suggestions: [],
    isPristineSearch: false,
    isUsingUserLocation: false,
    useUserLocationError: null,
    isUserLocationLoading: false,
    isUserLocationRequested: false,
    preferredStore: null,
    setIsUserLocationRequested: ()=>null
    ,
    clearSearch: ()=>null
    ,
    setSelectedLocation: ()=>null
    ,
    selectedLocation: '',
    setSuggestions: ()=>null
    ,
    setIsPristineSearch: ()=>null
    ,
    setStores: ()=>null
    ,
    setHoveredStore: ()=>null
    ,
    setSearchQuery: ()=>null
    ,
    setIsStoresLoading: ()=>null
    ,
    getStoreDetailsUrl: ()=>''
    ,
    setPreferredStore: ()=>null
    ,
    appliedStoreFilters: {},
    appliedStoreFilterCount: 0,
    toggleAppliedStoreFilter: ()=>null
    ,
    clearAppliedStoreFilters: ()=>null
};
const StoreFinderContext = /*#__PURE__*/ React.createContext(storeFinderContextDefaultValues);
const useStoreFinderContext = ()=>{
    const context = React.useContext(StoreFinderContext);
    if (context === storeFinderContextDefaultValues) {
        throw new Error('No StoreFinderContext available. You might still need to wrap the application with the StoreFinderProvider component.');
    }
    return context;
};
StoreFinderContext.displayName = 'StoreFinder';
const StoreFinderConsumer = StoreFinderContext.Consumer;

export { StoreFinderConsumer, StoreFinderContext, storeFinderContextDefaultValues, useStoreFinderContext };
//# sourceMappingURL=context.js.map
